import React, { Component } from "react";
import copy from "copy-to-clipboard";
import ToggleSwitch from './ToggleSwitch.jsx';
import { TableRow, TableCell } from "../../ui/table";
import { Button } from "../../ui/button";
import { Badge } from "../../ui/badge";
import { 
    MoreVertical, 
    Edit, 
    UserX, 
    Key, 
    Users, 
    Link as LinkIcon, 
    Mail, 
    AlertCircle,
    Phone as PhoneIcon,
    Loader2
} from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
class Users_no_row extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false,
            copy_tooltip: 'Migration Link - Click to Copy',
            copy_tooltip1: 'Copy Activation Link',
            copy_phone_tooltip1: 'Copy Phone Number',
            loading: false,
            dropdownOpen: false
        };
        this.Copytext = this.Copytext.bind(this);
        this.Copytext1 = this.Copytext1.bind(this);
        this.Copyphone = this.Copyphone.bind(this);
        this.tiercommissionFunc = this.tiercommissionFunc.bind(this);
        this.secondarycardFunc = this.secondarycardFunc.bind(this);
    }
    componentDidMount() {
        // Component mounted
    }

    componentWillUnmount() {
        // Component will unmount
    }
    Copytext = (e) => {
        copy(window.location.origin + "/" + e.target.getAttribute('data-text'));
        this.setState({ copy_tooltip: "Copied" });
        setTimeout(() => {
            this.setState({ copy_tooltip: "Migration Link - Click to Copy" });
        }, 600)
    }
    Copytext1 = (e) => {
        copy(window.location.origin + "/" + e.target.getAttribute('data-text'));
        this.setState({ copy_tooltip1: "Copied" });
        setTimeout(() => {
            this.setState({

                copy_tooltip1: "Copy Activation Link"
            });

        }, 600)
    }
    Copyphone = (e) => {
        copy(e.target.getAttribute('data-text'));
        this.setState({ copy_phone_tooltip1: "Copied" });
        setTimeout(() => {
            this.setState({

                copy_phone_tooltip1: "Copy Phone Number"
            });

        }, 600)
    }
    handleRowPagin = (e) => {
        this.props.userPagin(e);
    }
    tiercommissionFunc = async (e) => {
        this.setState({ loading: true });
        await this.props.TierCommission(e);
        this.setState({ loading: false });
    }
    
    secondarycardFunc = async (e) => {
        this.setState({ loading: true });
        await this.props.SecondaryCard(e);
        this.setState({ loading: false });
    }
    render() {
        const { 
            userName, 
            firstName, 
            lastName, 
            email, 
            groupNumber, 
            userStatus, 
            userId, 
            referral_Link_Request_Status, 
            isMigrated, 
            setupLink, 
            paymentStatus, 
            mailStatus, 
            phone, 
            tierCommission_Setting, 
            secondarycard 
        } = this.props;

        if (!userName) {
            return (
                <TableRow>
                    <TableCell colSpan={7} className="text-center py-8 text-gray-500">
                        No Record Found
                    </TableCell>
                </TableRow>
            );
        }

        const getStatusBadge = (status) => {
            if (status === "Active") {
                return <Badge className="bg-green-100 text-green-800 hover:bg-green-100">Active</Badge>;
            }
            if (status === "Profile Pending") {
                return <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">Profile Pending</Badge>;
            }
            return <Badge className="bg-gray-100 text-gray-800 hover:bg-gray-100">{status}</Badge>;
        };

        return (
            <TableRow className="hover:bg-gray-50">
                <TableCell className="font-medium text-brand-dark">{userName}</TableCell>
                <TableCell className="text-brand-dark">
                    {firstName} {lastName}
                </TableCell>
                <TableCell className="text-brand-dark max-w-xs">
                    <div className="flex items-center gap-2">
                        <span className="truncate">{email}</span>
                        {mailStatus === 'Risky' && (
                            <div className="group relative">
                                <AlertCircle className="h-4 w-4 text-red-500 cursor-help" />
                                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10">
                                    This email was flagged as risky
                                </div>
                            </div>
                        )}
                    </div>
                </TableCell>
                <TableCell className="text-brand-dark">{groupNumber}</TableCell>
                <TableCell>{getStatusBadge(userStatus)}</TableCell>
                <TableCell>
                    <ToggleSwitch 
                        tabName={this.props.tabName} 
                        rowPagin={this.handleRowPagin} 
                        userstatus={userStatus} 
                        numbering={userId} 
                        payment={paymentStatus} 
                        username={userName} 
                        email={email} 
                        setStateOfParent={this.props.setStateOfParent} 
                    />
                </TableCell>
                <TableCell className="text-right">
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                                <MoreVertical className="h-4 w-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className="w-56">
                            {this.state.loading && (
                                <div className="flex items-center justify-center p-2">
                                    <Loader2 className="h-4 w-4 animate-spin text-brand-accent" />
                                </div>
                            )}
                            
                            {!this.state.loading && (
                                <>
                                    {userStatus === "Active" && (
                                        <>
                                            <DropdownMenuItem 
                                                onClick={() => this.props.toggle_add_edit_popup({ 
                                                    target: { 
                                                        getAttribute: (attr) => attr === 'repid' ? userId : firstName + " " + lastName 
                                                    } 
                                                })}
                                            >
                                                <Edit className="mr-2 h-4 w-4" />
                                                Edit User
                                            </DropdownMenuItem>
                                            
                                            <DropdownMenuItem 
                                                onClick={() => this.props.activate_deactivate({ 
                                                    target: { 
                                                        getAttribute: (attr) => attr === 'status' ? 'Deactivate' : userId 
                                                    } 
                                                })}
                                                className="text-red-600 focus:text-red-600"
                                            >
                                                <UserX className="mr-2 h-4 w-4" />
                                                Deactivate User
                                            </DropdownMenuItem>
                                            
                                            <DropdownMenuItem 
                                                onClick={() => this.props.ClosePopUp({ 
                                                    target: { 
                                                        getAttribute: (attr) => userId 
                                                    } 
                                                })}
                                            >
                                                <Key className="mr-2 h-4 w-4" />
                                                Change Credentials
                                            </DropdownMenuItem>
                                            
                                            <DropdownMenuItem 
                                                onClick={() => this.props.toggle_refferal_pop({ 
                                                    target: { 
                                                        getAttribute: (attr) => {
                                                            if (attr === 'numbering') return userId;
                                                            if (attr === 'name_user') return userName;
                                                            if (attr === 'user_fullname') return firstName + " " + lastName;
                                                        }
                                                    } 
                                                })}
                                            >
                                                <Users className="mr-2 h-4 w-4" />
                                                Referrals
                                            </DropdownMenuItem>
                                            
                                            <DropdownMenuSeparator />
                                            
                                            <div className="px-2 py-1.5 text-sm">
                                                <label className="flex items-center gap-2 cursor-pointer">
                                                    <input 
                                                        type="checkbox" 
                                                        checked={tierCommission_Setting} 
                                                        onChange={this.tiercommissionFunc}
                                                        numbering={userId}
                                                        name_user={userName}
                                                        email_user={email}
                                                        className="rounded border-gray-300"
                                                    />
                                                    <span className="text-sm">Commission Tiers</span>
                                                </label>
                                            </div>
                                            
                                            <div className="px-2 py-1.5 text-sm">
                                                <label className="flex items-center gap-2 cursor-pointer">
                                                    <input 
                                                        type="checkbox" 
                                                        checked={secondarycard} 
                                                        onChange={this.secondarycardFunc}
                                                        numbering={userId}
                                                        name_user={userName}
                                                        email_user={email}
                                                        className="rounded border-gray-300"
                                                    />
                                                    <span className="text-sm">Display Secondary Cards</span>
                                                </label>
                                            </div>
                                            
                                            {isMigrated === false && (
                                                <>
                                                    <DropdownMenuSeparator />
                                                    <DropdownMenuItem 
                                                        onClick={(e) => {
                                                            e.target.setAttribute('data-text', setupLink);
                                                            this.Copytext(e);
                                                        }}
                                                    >
                                                        <LinkIcon className="mr-2 h-4 w-4" />
                                                        {this.state.copy_tooltip}
                                                    </DropdownMenuItem>
                                                </>
                                            )}
                                        </>
                                    )}
                                    
                                    {this.props.isEmailActivated && userStatus !== "Profile Pending" && userStatus !== "Active" && (
                                        <DropdownMenuItem 
                                            onClick={() => this.props.activate_deactivate({ 
                                                target: { 
                                                    getAttribute: (attr) => attr === 'status' ? 'Activate' : userId 
                                                } 
                                            })}
                                            className="text-green-600 focus:text-green-600"
                                        >
                                            <Users className="mr-2 h-4 w-4" />
                                            Activate User
                                        </DropdownMenuItem>
                                    )}
                                    
                                    {userStatus === "Profile Pending" && userName.indexOf('rxh-user-') > -1 && (
                                        <DropdownMenuItem 
                                            onClick={(e) => {
                                                e.target.setAttribute('data-text', setupLink);
                                                this.Copytext(e);
                                            }}
                                        >
                                            <LinkIcon className="mr-2 h-4 w-4" />
                                            {this.state.copy_tooltip}
                                        </DropdownMenuItem>
                                    )}
                                    
                                    {!this.props.isEmailActivated && (
                                        <>
                                            <DropdownMenuSeparator />
                                            <DropdownMenuItem 
                                                onClick={() => this.props.resendActivationApi({ 
                                                    target: { 
                                                        getAttribute: (attr) => {
                                                            if (attr === 'status') return 'sent';
                                                            if (attr === 'numbering') return userId;
                                                            if (attr === 'name_user') return userName;
                                                        }
                                                    } 
                                                })}
                                            >
                                                <Mail className="mr-2 h-4 w-4" />
                                                Resend Verification
                                            </DropdownMenuItem>
                                            
                                            <DropdownMenuItem 
                                                onClick={(e) => {
                                                    e.target.setAttribute('data-text', setupLink);
                                                    this.Copytext1(e);
                                                }}
                                            >
                                                <LinkIcon className="mr-2 h-4 w-4" />
                                                {this.state.copy_tooltip1}
                                            </DropdownMenuItem>
                                            
                                            <DropdownMenuItem 
                                                onClick={(e) => {
                                                    e.target.setAttribute('data-text', phone);
                                                    this.Copyphone(e);
                                                }}
                                            >
                                                <PhoneIcon className="mr-2 h-4 w-4" />
                                                {this.state.copy_phone_tooltip1}
                                            </DropdownMenuItem>
                                        </>
                                    )}
                                </>
                            )}
                        </DropdownMenuContent>
                    </DropdownMenu>
                </TableCell>
            </TableRow>
        );
    }
}
export default Users_no_row;
